import { create } from "zustand";

const useUserStore = create((set) => ({
  isAuthenticated: false,
  user: null,
  tokenId: null,
  isLoading: false,
  error: null,
  allSessions: [],
  lastActivity: null,
  isMobile: false,
  activePage: "sidebar",
  isRecordingStarted: false,
  allSurgicalSession: [],

  setActivePage: (data) => set({ activePage: data }),
  setIsMobile: (data) => set({ isMobile: data }),
  setIsRecordingStarted: (data) => set({ isRecordingStarted: data }),

  login: async (payload) => {

    set({ isLoading: true, error: null });
    const dentistData = {
      first_name: payload.first_name,
      last_name: payload.last_name,
      email_id: payload.email,
      phone_number: "1283383888",
      registration_number: "RWASDE38266",
      designation: "Doctor"
    };
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/dentists`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${payload.token_id}`,
        },
        body: JSON.stringify(dentistData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      const newData = {
        dentist_id: data.dentist_id,
        first_name: payload.first_name,
        last_name: payload.last_name,
        email_id: payload.email
      };
      set({ user: newData, tokenId: payload.token_id, isLoading: false, isAuthenticated: true });
      console.log("Dentist created successfully:", data);
      return data
    } catch (error) {
      set({ error: error.message, isLoading: false });
      console.error("Error creating dentist:", error);
      throw error
    }
  },

  logout: () => {
    set({
      user: null,
      isAuthenticated: false,
      tokenId: null,
      lastActivity: null
    });
    sessionStorage.removeItem("token")
  },

  updateLastActivity: () =>
    set({
      lastActivity: new Date().toISOString(),
    }),

  manualLogin: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/auth/login`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email_id: email,
            password: password,
          }),
        }
      );

      const data = await response.json(); // always call this before checking status
      console.log(data)
      if (!response.ok) {
        // Create a new error object with status and detail
        const error = new Error(data.detail || "Unknown error");
        error.status = response.status;  // manually attach status code
        throw error;
      }

      const userData = {
        dentist_id: data?.data?.dentist_id,
        first_name: data?.data?.first_name,
        last_name: data?.data?.last_name,
        email_id: data?.data?.email_id,
      };

      set({
        user: userData,
        tokenId: data?.data?.token,
        isLoading: false,
        isAuthenticated: true,
      });

      sessionStorage.setItem("token", data.data.token);
      return data.data;
    } catch (error) {
      console.error("Login failed:", error.status, error.message);
      set({
        error: error.message || "Unexpected error",
        isLoading: false,
      });
      throw error;
    }
  },

  resetPassword: async ( email_id, old_password, new_password ) => {
    set({ isLoading: true, error: null });
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/auth/reset_password`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email_id, old_password, new_password }),
      });

      const data = await response.json();
      set({isLoading:false})
      
      if (!response.ok) {
        const error = new Error(data.detail || "Unknown error");
        error.status = response.status;  // manually attach status code
        throw error;
      }
      console.log('Password reset successful:', data);
      return data;
    } catch (error) {
      console.error('Error:', error.message);
      set({
        error: error.message || "Unexpected error",
        isLoading: false,
      });
      throw error;
    }
  },


  fetchUser: async (token) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/auth/me`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch user details");
      }

      const data = await response.json();
      const userData = {
        dentist_id: data.data.dentist_id,
        first_name: data.data.first_name,
        last_name: data.data.last_name,
        email_id: data.data.email_id,
      };
      set({
        user: userData,
        tokenId: token,
        isLoading: false,
        isAuthenticated: true,
      });

      return userData;
    } catch (error) {
      console.error("Error fetching user:", error);
      return null;
    }
  },

  fetchSessions: async (dentist_id) => {
    const token = sessionStorage.getItem("token");
    const url = `${process.env.REACT_APP_SERVER_URL}/patients/${dentist_id}/patients`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      set({ allSessions: data })
      return data;
    } catch (error) {
      console.error("Error fetching sessions:", error);
      return null;
    }
  },
  fetchSurgicalData: async (dentistId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/surgical-note/${dentistId}/patients`, {
        method: 'GET',
        headers: {
          'accept': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      set({ allSurgicalSession: data })
      console.log('Fetched surgical data');
      return data;
    } catch (error) {
      console.error('Error fetching surgical data:', error);
      return null;
    }
  },

}));

export default useUserStore;
